import { createContext, PropsWithChildren } from "react";

/**
 * SliderContainerContextState
 */

export type SliderContainerContextState = {};

/**
 * SliderContainerContext
 */

export const SliderContainerContext = createContext<SliderContainerContextState>({});

/**
 * SliderContainerContextProvider
 */

export const SliderContainerContextProvider = ({ children }: PropsWithChildren) => {
  return (
    <SliderContainerContext.Provider value={{}}>
      <div className="size-full relative">
        <div className="size-full relative">
          {children}
        </div>

        {/*
        <div className="size-full absolute top-0 left-0 rigth-0 bottom-0 z-50 flex flex-row justify-end">
          <div className="w-[40rem] h-[100vh] bg-white shadow-xl flex flex-col">
            <div className="text-lg py-2 px-4">Title</div>
            <div className="w-full flex-1 bg-red-400 p-4"></div>
            <div className="text-lg py-2 px-4">Footer</div>
          </div>
        </div>
        */}
      </div>
    </SliderContainerContext.Provider>
  );
}